import { Component, HostBinding, OnInit } from '@angular/core'
import { Subscription } from 'rxjs'
import { TimerService } from '../core/services/timer.service'

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit {
  sideBarIsToggled = false
  sideBarIsCollapsed = false
  @HostBinding('class.aside-toggled') get asideToggled() {
    return this.sideBarIsToggled
  }
  @HostBinding('class.aside-collapsed') get asideCollapsed() {
    return this.sideBarIsCollapsed
  }
  version = (window as any).env.Version
  subscription: Subscription

  constructor(private timerService: TimerService) {}

  showSideBar = true

  ngOnInit() {}

  toggleSideBar() {
    this.sideBarIsToggled = !this.sideBarIsToggled
  }

  collapseSideBar() {
    this.sideBarIsCollapsed = !this.sideBarIsCollapsed
  }
}
